<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-07 19:46:49
 * @LastEditTime: 2019-10-09 17:18:47
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
            class="dealerDialog"
            title="选择经销商"
            :visible="true"
            :append-to-body=true
            width="60%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="经销商编号:">
                <el-input v-model="form.dealer_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="经销商名称:">
                <el-input v-model="form.dealer_name" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="关键词:">
                <el-input v-model="form.keywords" clearable placeholder="手机号、负责人"></el-input>
            </el-form-item> -->
                <el-form-item label="经销商级别:">
                        <el-select v-model="form.level_id" placeholder="请选择经销商级别" clearable>
                            <el-option v-for=" i in dealerLevel" :key="i.id" :label="i.level_name"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getDealer()">搜索</el-button>
            </el-form-item>
        </el-form>
        <span>提示：经销商资料请在【客户】-【经销商管理】中添加、管理</span>
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="300"
                border
                stripe
                @selection-change='select'
                style="margin: 20px 0">
                    <el-table-column
                    type="selection"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="dealer_sn"
                    label="经销商编号"
                    width="120"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="dealer_name"
                    label="经销商名称"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="level_name"
                    label="经销商级别"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="mobile"
                    label="手机号"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="person"
                    label="负责人"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="choose(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="confrim()">确 定</el-button>
  </span>
    </el-dialog>
    
</template>

<script>
import { filter } from 'minimatch';
    export default {
        name: "selectDealer",
        data () {
            return {
                loading:false,
                form: {
                    dealer_sn:'',
                    dealer_name:'',
                    keywords:'',
                },
                tableData: [],
                stockArray: [],//仓库
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                dealerLevel:[],
                selects:[]
            }
        },
            props:{
       
           putaway:Object
        },
        methods:{
            getDealer(){
                console.log()
                this.loading = true;
                this.$get('logistics', '/dealers', {
                    lang: '',
                    dealer_sn: this.form.dealer_sn,
                    dealer_name: this.form.dealer_name,
                    level_id:this.form.level_id,
                    per_page: this.pageSize,
                    page: this.pageNo
                }).then(res => {
                    this.loading = false;

                    //console.log(res);
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                    //  this.tableData.forEach(element => {
                    //     dea_008
                    // });
                   this.tableData= this.tableData.filter((val)=>{
                      
                        return this.putaway.exclude_dealers.indexOf(val.dealer_sn)==-1
                    });
                }).catch(function (error) {
                    this.loading = false;

                    console.log(error);
                });
            },
            //选择经销商
            choose(row){
                this.$emit('pushData',row);
                this.$emit('handleClose');
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getDealer();
            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getDealer();
            },
            handleClose(){
                this.$emit('handleClose');
            },
            select(val){
                console.log(val)
                this.selects=val
            },
              //获取经销商级别
                getDealerLevel() {
                    this.$get('logistics', '/dealers.level', {}).then(res => {
                        //console.log(res);
                        this.dealerLevel = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                confrim(){
                 this.$emit('selsects',this.selects);
                    this.handleClose()
                }
        },
        created(){
            this.getDealer();
            this.getDealerLevel()

        }
    }
</script>

<style lang="scss" scoped>


</style>